import { ConversionApiTracker } from './conversion_api_tracker';
import { FbTracker } from './fb_tracker';
import { GoogleAnalyticsTracker } from './google_analytics_tracker';
import { OutbrainTracker } from './outbrain_tracker';
import { PinterestTracker } from './pinterest_tracker';
import { TikTokTracker } from './tiktok_tracker';
import { TwitterTracker } from './twitter_tracker';
import { PostHogTracker } from './posthog_tracker';
import { MgidTracker } from './mgid_tracker';
import msg from '../../messages';
import store from '../store';

export default class Tracker {
    #services;
    #pixelDelay = 2000;
    #defaultPayment = 'Credit Card';
    #eventData;

    constructor() {
        this.#eventData = this.#gatherEventData();
        this.#services = [
            new GoogleAnalyticsTracker(this.#eventData),
            new FbTracker(this.#eventData),
            new PinterestTracker(this.#eventData),
            new TikTokTracker(this.#eventData),
            // new OutbrainTracker(this.#eventData),
            new TwitterTracker(this.#eventData),
            // new PostHogTracker(this.#eventData),
            new ConversionApiTracker(this.#eventData),
            // new MgidTracker(this.#eventData),
        ];
    }

    firePixelEvent(event) {
        this.#services.forEach((service) => {
            this.#fireEvent(service, event, (s) => s.firePixelEvent(event));
        });
    }

    firePurchaseEvent(price, orderId, currency) {
        this.#services.forEach((service) => {
            this.#fireEvent(service, 'purchase_complete', (s) => s.firePurchaseEvent(price, orderId, currency));
        });

        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve();
            }, this.#pixelDelay);
        });
    }

    fireCheckoutStartedEvent() {
        this.#services.forEach((service) => {
            this.#fireEvent(service, 'checkout_started', (s) => s.fireCheckoutStartedEvent());
        });
    }

    fireAddPaymentInfoEvent(paymentType = this.#defaultPayment) {
        this.#services.forEach((service) => {
            this.#fireEvent(service, 'added_payment_info', (s) => s.fireAddPaymentInfoEvent(paymentType));
        });
    }

    #fireEvent(service, event, callback) {
        const eventType = store.state.progressTrackingTriggered[event] ?? null;

        if (!eventType) {
            return;
        }

        if (eventType.includes(service.serviceName)) {
            return;
        }

        eventType.push(service.serviceName);

        try {
            callback(service);
        } catch (err) {
            logger.captureException(new Error(msg.tracking.firePixelFailed), { extra: err });
        }
    }

    #gatherEventData() {
        return {
            name: store.getters.product.progress_tracking_slug,
            title: store.getters.product.title,
            currency: store.state.currency ? store.getters.product.price.full.currency : 'USD',
            session_id: store.state.sessionId,
        };
    }
}
